import React from "react";
import LegalPage from "./LegalPage";

export default function TermsOfService() {
  return <LegalPage title="Terms of Service" />;
}
